import React, { useCallback, useEffect, useState } from "react";
import { useLocation, useMatch, useNavigate, useResolvedPath } from "react-router-dom";

const MenuItem = (props) => {
    const navigate = useNavigate();
    const resolved = useResolvedPath(props.to);
    const rmatched = useMatch({ path: resolved.pathname, end: props.to === "/" });

    const handleNavigate = useCallback(
        (e) => {
            e.preventDefault();
            navigate(props.to);
        },
        [props.to, navigate],
    );

    return (
        <li className="nav-item nav-item-style">
            <a href="#" onClick={handleNavigate} className={`nav-link ${rmatched ? "active" : "nav-link-style"}`}>
                {props.children}
            </a>
        </li>
    );
};

export default function MenuComponent() {
    // const navigate = useNavigate();
    // const location = useLocation();
    // const pathname = location?.pathname;

    // const [currentPage, setCurrentPage] = useState("");

    // useEffect(() => {
    //     if (pathname) {
    //         setCurrentPage(pathname);
    //     }
    // }, [pathname]);

    // const nextPage = (target) => {
    //     if (target) {
    //         navigate(target);
    //     }
    // };

    return (
        <div>
            <ul className="nav nav-tabs nav-bar-style justify-content-center fs-4" style={{ width: "fit-content" }}>
                <MenuItem to="/">Home</MenuItem>
                <MenuItem to="/search">Search</MenuItem>
                <MenuItem to="/tools">Tools</MenuItem>
            </ul>
        </div>
    );
}
